import React from "react";
import CardprojectComponent from "../Client/dashboardComponents/CardprojectComponent";
import SkeletonLoader from "../Utils/Skeleton";

export const ProjectsList = ({ projects, isLoading }) => {
  const skeletonTab = Array.from({ length: 4 }, (_, i) => ({
    id: `skeleton${i + 1}`,
  }));

  if (isLoading) {
    return (
      <div className="flex max-md:gap-5 gap-7 w-[90%] flex-wrap pb-1">
        {skeletonTab.map((elem, i) => (
          <SkeletonLoader {...elem} key={i} cardProject={true} />
        ))}
      </div>
    );
  }

  if (projects.length === 0) {
    return (
      <h1 className="text-sm font-sans font-semibold text-center">
        Aucun projet disponible pour le moment
      </h1>
    );
  }

  return (
    <div className=" mt-20 grid grid-cols-4 max-lg:grid-cols-3 max-md:grid-cols-1 gap-4 w-[90%]">
      {projects.map((projet, index) => (
        <CardprojectComponent
          key={index}
          image={projet?.image}
          budget={projet?.budget}
          titre={projet?.titre}
          objectif={projet?.objectif}
          path={`/projets/${projet?.slug}`}
        />
      ))}
    </div>
  );
};
